import i18n from '@/plugins/i18n';

export function formatNumber(input, prefix = '', suffix = '', toFixed = null) {
    if (!input || (typeof input !== 'string' && typeof input !== 'number')) {
        return input;
    }
    const numberString = input.toString().replace(/[^\d.-]/g, '');
    const number = parseFloat(numberString);

    if (isNaN(number)) {
        return input;
    }

    const options = {};
    if (toFixed !== null) {
        options.minimumFractionDigits = toFixed;
        options.maximumFractionDigits = toFixed;
    }

    const formattedNumber = new Intl.NumberFormat(i18n.global.locale, options).format(number);

    return `${prefix}${formattedNumber}${suffix}`;
}

export function formatSbiCode(code) {
    if (!code) return '';
    return code.replace(/(.{2})(?=.)/g, '$1.');
}

export function formatDateReverse(date) {
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
}

export function formatTextRange(input, prefix = '', suffix = '') {
    if (!input || (typeof input !== 'string' && typeof input !== 'number')) {
        return input;
    }

    let elements = input.split(':');
    let outputElements = [];

    elements.forEach((e) => {
        if(e.includes('+')) {
            e = e.replace('+', '');
            outputElements.push(`${prefix}${formatNumber(e, '', suffix + '+')}`);
        } else {
            outputElements.push(`${prefix}${formatNumber(e)}${suffix}`);
        }
    });
    return outputElements.join(' - ');
}

export function formatCustomQuery(customQuery) {
    const escapeHtml = (str) =>
        str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    
    let escaped = escapeHtml(customQuery);

    const orRegex = /(\|\||\bOR\b)/g;
    escaped = escaped.replace(orRegex, '<span class="operator-or">$1</span>');

    const andRegex = /(&amp;&amp;|&&|\bAND\b)/g;
    escaped = escaped.replace(andRegex, '<span class="operator-and">$1</span>');

    const leftBracketRegex = /(\(|\[)/g;
    escaped = escaped.replace(leftBracketRegex, '<span class="bracket-left">$1</span>');

    const rightBracketRegex = /(\)|\])/g;
    escaped = escaped.replace(rightBracketRegex, '<span class="bracket-right">$1</span>');

    const commasRegex = /(,)/g;
    escaped = escaped.replace(commasRegex, '<span class="comma">$1</span>');
    
    return escaped;
}